<template>
  <div class="info-container-temp" :id="scrollLink">
    <el-card :class="['box-card', infoTitle == ''?'no-title':'']" >
      <div slot="header" class="box-header" v-if="infoTitle">
        <span class="box-header-title">{{infoTitle}}
          <el-input class="process_instance_name"  size="medium"  v-if="isEditName" v-model="processInstanceName" placeholder="请输入流程名称" @input="setProcessInstanceName"></el-input>
        </span>
        
        <span class="box-header-warn" type="text" v-if="warnIcon"> 
          带<span class="red-point">*</span>&nbsp;为必填项
        </span>
      </div>
      <div class="detail-content">
        <template v-for="(item, index) in contentConfig">
          <div class="detail-one" :key="`${item.prop}-${index}`" v-if="item.display && item.display == 'false'?false:true">
            <div class="detail-top" v-if="item.title">
              <div class="detail-title">
                {{item.title}}
                <span v-if="item.tips" class="title-tips">{{item.tips}}</span>
              </div>
            </div>
            <div class="detail-content">
              <slot :name="item.prop"></slot>
            </div>
          </div>
        </template>
        <slot></slot>
      </div>
    </el-card>
  </div>
</template>
<script>

import {debounce} from "@/util/util";

let that=null
export default {
  name:'InfoContainer',
  data() {
    return {}
  },
  props: {
    /**
     * @param {String} infoTitle 页面信息块数组
     * @param {Array} contentConfig 页面信息块数组 [{title, prop, display}]
     * @param {Boolean} warnIcon 是否显示必填提示
     */
    infoTitle: {
      type: String,
      default: '项目信息'
    },
    contentConfig: {
      required: true,
      type: Array
    },
    warnIcon: {
      type: Boolean,
      default: false
    },
    // 默认跳转表示
    scrollLink: {
      type: String,
      default: 'infoHead'
    },
    // 是否需要修改流程名字
    isEditName: {
      type: Boolean,
      default: false
    },
    // 流程名字
    processInstanceName: {
      type: String,
      default: ''
    }
  },
  mounted() {
    that=this
   
  },
  beforeDestroy() {
    //组件销毁前，把定义的滞空
    that=null
  },
  methods:{
    setProcessInstanceName:debounce((value)=>{
      that.$emit("setProcessInstanceName",value)
    }, 1000),

    // setProcessInstanceName(value){
    //   this.$emit("setProcessInstanceName",value)
    // },
  }

}
</script>
<style lang="scss">
.info-container-temp{
  .box-card{
    background-color: #fff;
    border-radius: 10px;
    margin-bottom: 20px !important;
    border: 1px solid #e9e9e9 !important;
    .el-card__header{
      background-color: #f9f9f9 !important;
    }    
    .red-point{
      color: red;
    }
    .box-header{

      background-color: #f9f9f9 !important;
      padding: 10px 5px;
    }
    .box-header-title{
      color: rgb(51,51,51);
      font-weight: 400;
      font-size: 16px;
      display: flex;
      align-items: center;
    }
    .box-header-warn{
      float: right;
      padding: 3px 0;
      color: #999;
      .red-point{
        color: red;
      }      
    }
    .detail-one{
      padding: 20px 50px !important;
      .detail-top{
        padding: 20px 5px;
        .detail-title{
          color: #666;
          font-weight: 700;
          font-size: 14px;
          line-height: 28px;
          position: relative;
          .title-tips{
            font-weight: 400;
            color: #666666;
            font-size: 13px;
          }
        }
        .detail-title::before{
          content: '';
          width: 5px;
          background-color: #409EFF;
          height: 18px;
          position: absolute;
          left: -12px;
          top: 5px;
        }
      }
    }

  }

  .no-title{
    .el-card__header{
      height: 0 !important;
      padding: 0 !important;
    }
  }    
} .process_instance_name {
  margin-left:20px;
  width:450px
  
}
</style>